// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NF3Gq","placeholdersHeader":"styles_placeholdersHeader__2NenZ","editorStyle":"styles_editorStyle__1j4Ly","placeholdersBox":"styles_placeholdersBox__10yAE"};